import React from 'react';

const ContactMap = () => {
  return (
    <div className="w-full h-full relative">
      {/* Bingkai Luar Efek Shadow Premium */}
      <div className="w-full aspect-[4/3] md:aspect-[16/10] xl:aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl shadow-slate-200/80 border-4 border-white z-10 transition-transform duration-500 hover:scale-[1.01]">
        <iframe
          title="maps-kin"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4742.512518246244!2d106.80756504289744!3d-6.227130554793969!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f1e85be81753%3A0x49ab9e61694e8558!2sKiN%20Space%20SCBD!5e0!3m2!1sid!2sid!4v1722656772573!5m2!1sid!2sid" // Pastikan ini diisi dengan link embed Google Maps Anda yang valid
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="w-full h-full grayscale-[10%] contrast-[110%] hover:grayscale-0 transition-all duration-500"
        />
      </div>
    </div>
  );
};

export default ContactMap;
